
import { Button } from "@/components/ui/button";

const CentralIllustrationSection = () => {
  return (
    <section className="py-12 bg-seo-light">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="bg-white rounded-xl overflow-hidden shadow-lg">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-1/2 p-8 md:p-12 flex items-center">
              <div>
                <h3 className="text-2xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-seo-primary to-seo-secondary">SEO Local é o caminho para o crescimento do seu negócio</h3>
                <p className="text-gray-600 mb-6">
                  Quando potenciais clientes buscam serviços na sua região, eles precisam encontrar você primeiro. Com SEO Local, sua empresa aparece exatamente quando e onde seus clientes estão procurando.
                </p>
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <Button 
                    onClick={() => window.open('https://wa.me/5555115197440?text=Ol%C3%A1%2C%20quero%20uma%20analise%20da%20LocalUP.', '_blank')}
                    className="bg-green-500 hover:bg-green-600 text-white flex items-center gap-2 transform transition-all duration-300 hover:-translate-y-1"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                    </svg>
                    Fale conosco no WhatsApp
                  </Button>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 bg-gradient-to-br from-blue-50 to-blue-100 flex items-center justify-center p-8 md:p-12">
              <div className="relative w-full max-w-md">
                <div className="rounded-lg overflow-hidden shadow-xl">
                  <img 
                    src="https://images.unsplash.com/photo-1498050108023-c5249f4df085" 
                    alt="Pessoa usando um laptop com gráficos de SEO" 
                    className="w-full h-auto"
                  />
                </div>
                <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-lg shadow-lg max-w-[200px]">
                  <div className="flex items-center mb-2">
                    <div className="text-yellow-500 flex">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-gray-600">
                    "Minha empresa passou da terceira página para a primeira posição no Google!"
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CentralIllustrationSection;
